import { createFileRoute, Outlet } from "@tanstack/react-router";

import {
  requiresCurrentUser,
  requiresOnboarding,
  requiresWorkOSAuth,
} from "@/providers/auth/utils";

import { posthogIdentify } from "@/utils/identify";

export const Route = createFileRoute("/_secure")({
  beforeLoad: ({ context, location }) => {
    requiresWorkOSAuth(context, location);
    requiresCurrentUser(context, location);
    posthogIdentify(context);
    requiresOnboarding(context);
  },
  component: SecureRouteComponent,
});

function SecureRouteComponent() {
  return <Outlet />;
}
